// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2OhHe","container":"styles_container__g8iu6","title":"styles_title__jOXE1","wrapper":"styles_wrapper__3R_Ni","answer":"styles_answer__35AQL"};